interface IUserTags {
	Member: string,
	Host: string
}

export const userTags: IUserTags = {
	Member: 'Member',
	Host: 'Host'
}